import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=50b026c5&"
import script from "./StackedBarChart.vue?vue&type=script&lang=ts&"
export * from "./StackedBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./StackedBarChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports